import Vue from 'vue'
import VueI18n from 'vue-i18n'

export const defaultLang = 'pl'

Vue.use(VueI18n)
Vue.config.lang = defaultLang

const messages = {
  pl: {
    sdkDocs: 'Autopay SDK - Dokumentacja',
    home: {
      heading: 'Portal dla developera',
      api: 'wygodne płatności',
      sdk: 'płatności mobilne'
    },
    menu: {
      about: 'O produkcie',
      documentation: 'Dokumentacja',
      download: 'Pliki do pobrania',
      faq: 'FAQ',
      changelog: 'Changelog'
    },
    contactUs: {
      question: 'Masz pytania?',
      contactUs: 'Jeśli nie znalazłeś odpowiedzi skontaktuj się z nami',
      contactUsBtn: 'Skontaktuj się'
    },
    footer: {
      contact: 'Kontakt',
      individualCustomer: 'klient indywidualny',
      companyCustomer: 'klient firmowy'
    },
    homePage: {
      heading: 'Portal dla developera'
    },
    weekDays: {
      mo: 'pon',
      fr: 'pt'
    },
    printFirstPage: {
      project: 'Projekt',
      title: 'Tytuł',
      type: 'Rodzaj',
      documentDescription: 'Opis dokumentu',
      version: 'Wersja'
    },
    goToSection: {
      seeAlso: 'Zobacz także',
      documentation: 'Dokumentacja Autopay SDK',
      description: 'Przygotowaliśmy dedykowaną dokumentację z licznymi przykładami użycia dla platform',
      link: 'Przejdź',
      and: 'i',
      download: 'Pliki do pobrania',
      filesDescription: 'Udostępnimy pliki instalacyjne biblioteki oraz aplikacji demonstracyjnej dla platform'
    }
  },
  en: {
    sdkDocs: 'Autopay SDK - Documentation',
    home: {
      heading: 'For Developer',
      api: 'convenient payments',
      sdk: 'mobile payments'
    },
    menu: {
      about: 'About product',
      documentation: 'Documentation',
      download: 'Download',
      faq: 'FAQ',
      changelog: 'Changelog'
    },
    contactUs: {
      question: 'Got a question?',
      contactUs: "If you've not found the answer, please contact us",
      contactUsBtn: 'Contact us'
    },
    footer: {
      contact: 'Contact',
      individualCustomer: 'individual customer',
      companyCustomer: 'company customer'
    },
    homePage: {
      heading: 'For developer'
    },
    weekDays: {
      mo: 'Mo.',
      fr: 'Fr.'
    },
    printFirstPage: {
      project: 'Project',
      title: 'Title',
      type: 'Type',
      documentDescription: 'Document description',
      version: 'Version'
    },
    goToSection: {
      seeAlso: 'See also',
      documentation: 'Autopay SDK Documentation',
      description: 'We have prepared a dedicated documentation with numerous examples of use for Android and iOS platforms',
      link: 'See more',
      and: 'and',
      download: 'Download',
      filesDescription: 'We will provide installation files for the library and demo application for platforms'
    }
  }
}

export default new VueI18n({
  locale: defaultLang,
  fallbackLocale: defaultLang,
  messages
})
